const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div id="case-study-listings">
  <div class="c-cloud-cover t-dark">
    <div class="o-container o-container--pad-inline">
      <div class="o-container__content c-cloud-cover__inner">
        <div class="c-cloud-cover__content">
          <div class="o-rhythm o-rhythm--condensed">
            <h1 class="c-heading c-heading--level-n2">Our Work</h1>
            <p>
              We’ve built responsive websites, JavaScript applications, hybrid apps, you name it—if it’s mobile, we’ve built it.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="top-wrapper o-container o-container--pad">
    <div class="o-container__content">
      <div class="o-deck o-deck--2-column@l">
        <article class="c-card c-card--with-link c-card--horizontal@m">
          <header class="c-card__header">
            <h2 class="c-card__heading">
              <a
                href="#"
                class="c-card__link"
              >
                Champion Power Equipment
              </a>
            </h2>
          </header>

          <div class="c-card__cover">
            <img
              src="`);
                this.echo(this.env.getFilter('escape').traceableCallable(34, this.source)(...[this.env, (context.has(`cpe`) ? context.get(`cpe`) : null), `html`, null, true]));
                this.echo(`"
              alt=""
            />
          </div>

          <div class="c-card__content">
            <p>
              Champion Power Equipment is a market leader in power generation equipment. They chose Cloud Four to design...
            </p>
          </div>
        </article>

        <article class="c-card c-card--with-link">
          <header class="c-card__header">
            <h2 class="c-card__heading">
              <a
                href="#"
                class="c-card__link"
              >
                Walmart Grocery
              </a>
            </h2>
          </header>

          <div class="c-card__cover">
            <img
              src="`);
                this.echo(this.env.getFilter('escape').traceableCallable(60, this.source)(...[this.env, (context.has(`wm`) ? context.get(`wm`) : null), `html`, null, true]));
                this.echo(`"
              alt=""
            />
          </div>

          <div class="c-card__content">
            <p>
              Cloud Four was hired to help Walmart make the transition to responsive web design. We started with the smaller Walmart Grocery site, built a pattern library, and converted...
            </p>
          </div>
        </article>

        <article class="c-card c-card--with-link">
          <header class="c-card__header">
            <h2 class="c-card__heading">
              <a
                href="#"
                class="c-card__link"
              >
                Ceasefire Oregon
              </a>
            </h2>
          </header>

          <div class="c-card__cover">
            <img
              src="`);
                this.echo(this.env.getFilter('escape').traceableCallable(86, this.source)(...[this.env, (context.has(`cf`) ? context.get(`cf`) : null), `html`, null, true]));
                this.echo(`"
              alt=""
            />
          </div>

          <div class="c-card__content">
            <p>
              Ceasefire Oregon is a small, non-profit organization in Llanfairpwllgwyngyllgogerychwyrndrobwllllantysiliogogogoch working for sensible gun law reform. Their site had a wealth of information, but was difficult to navigate and read. We helped...
            </p>
          </div>
        </article>
      </div>

      <div class="container-wrap">
        <div class="intro">
          <p class="c-heading--level-3">More clients we’ve worked with</p>
        </div>
        `);
                this.echo(this.include(context, this.source, this.loadTemplate(`6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 103, 54), undefined, true, false, 103));
                this.echo(`      </div>

    </div>
  </div>

  <div class="wrapper t-alternate">
    <div class="o-container o-container--pad">
      <div class="o-container__content u-pad-block-2">
        `);
                this.echo(this.include(context, this.source, this.loadTemplate(`6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 118, 58), undefined, true, false, 118));
                this.echo(`      </div>
    </div>
  </div>

  <div class="wrapper">
    <div class="o-container o-container--pad">
      <div class="o-container__content u-pad-block-2">
        `);
                this.echo(this.include(context, this.source, this.loadTemplate(`6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 176, 65), undefined, true, false, 176));
                this.echo(`      </div>
    </div>
  </div>

  `);
                this.echo(this.include(context, this.source, `@cloudfour/components/ground-nav/ground-nav.twig`, new Map([[`menu`, new Map([[`items`, new Map([[0, new Map([[`link`, `/does`], [`title`, `What We Do`], [`current`, true]])], [1, new Map([[`link`, `/believes`], [`title`, `Our Approach`]])], [2, new Map([[`link`, `/made`], [`title`, `Our Work`]])], [3, new Map([[`link`, `/thinks`], [`title`, `Articles`]])], [4, new Map([[`link`, `/presents`], [`title`, `Speaking`]])], [5, new Map([[`link`, `/contributes`], [`title`, `Labs`]])], [6, new Map([[`link`, `/is`], [`title`, `Team`]])], [7, new Map([[`link`, `/portland-device-lab`], [`title`, `Device Lab`]])], [8, new Map([[`link`, `https://cloudfour-patterns.netlify.app/`], [`title`, `Patterns`]])], [9, new Map([[`link`, `https://www.responsivefieldday.com/`], [`title`, `Responsive Field Day`]])]])]])], [`social`, new Map([[`items`, new Map([[0, new Map([[`link`, `https://twitter.com/cloudfour`], [`title`, `Follow us on Twitter`], [`icon`, `brands/twitter`]])], [1, new Map([[`link`, `https://github.com/cloudfour`], [`title`, `Find us on GitHub`], [`icon`, `brands/github`]])], [2, new Map([[`link`, `https://www.instagram.com/cloudfourpdx/`], [`title`, `Follow us on Instagram`], [`icon`, `brands/instagram`]])], [3, new Map([[`link`, `https://www.linkedin.com/company/cloud-four`], [`title`, `Follow us on LinkedIn`], [`icon`, `brands/linkedin`]])]])]])], [`action`, new Map([[`lead_in`, `Let’s discuss your project!`], [`title`, `Email us`], [`link`, `mailto:info@cloudfour.com`], [`icon`, `envelope`]])], [`organization`, new Map([[`name`, `Cloud Four, Inc.`], [`address`, new Map([[`street_address`, `510 SW 3rd Ave, Suite 420`], [`address_locality`, `Portland`], [`address_region`, `Oregon`], [`postal_code`, `97204`], [`address_country`, `USA`]])], [`email`, `info@cloudfour.com`], [`telephone`, `+1 (503) 290-1090`], [`url`, `https://cloudfour.com/`], [`founding_date`, `2007-12-13`]])]]), false, false, 291));
                this.echo(`</div>
`);
            }

            getTemplateName() {
                return `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, ``);
            }
        }],
        [54, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/logo-group/logo-group.twig`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 103);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/logo-group/logo-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable((context.has(`logos`) ? context.get(`logos`) : null));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`logo`] = __value__;
                    this.echo(`              <img src="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(106, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 106, this.source)(this.env, context.get(`logo`), `image`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`" alt="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(106, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 106, this.source)(this.env, context.get(`logo`), `title`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`">
            `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('logo');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`          `);
            }

            getTemplateName() {
                return `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, ``);
            }
        }],
        [58, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/feature-group/feature-group.twig`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 118);

                this.blocks = new Map([
                    ['intro', [this, 'block_intro']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/feature-group/feature-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_intro(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            <h2 class="c-heading c-heading--level-0 c-heading--light">
              Books we’ve written
            </h2>
          `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            `);
                this.echo(this.include(context, this.source, this.loadTemplate(`6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 125, 57), new Map([[`class`, `o-deck--1-column@s o-deck--2-column@l o-deck--align-start`]]), false, false, 125));
                this.echo(`          `);
            }

            getTemplateName() {
                return `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, ``);
            }
        }],
        [57, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/deck/deck.twig`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 125);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/deck/deck.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                `);
                this.echo(this.include(context, this.source, this.loadTemplate(`6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 129, 55), new Map([[`class`, `o-media--1-by-2@l`]]), false, false, 129));
                this.echo(`                `);
                this.echo(this.include(context, this.source, this.loadTemplate(`6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 147, 56), new Map([[`class`, `o-media--1-by-2@l`]]), false, false, 147));
                this.echo(`              `);
            }

            getTemplateName() {
                return `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, ``);
            }
        }],
        [55, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/media/media.twig`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 129);

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/media/media.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    <img
                      src="media/home-page/bookicon.png"
                      alt=""
                      loading="lazy"
                      class="book-img"
                    />
                  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    <h3 class="u-pad-block-n1 u-pad-block-n2@l">
                      <a href="#" class="c-card__link">Progressive Web Apps</a>
                    </h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed...</p>
                  `);
            }

            getTemplateName() {
                return `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, ``);
            }
        }],
        [56, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/media/media.twig`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 147);

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/media/media.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    <img
                      src="media/bookicon2.png"
                      alt=""
                      loading="lazy"
                      class="book-img"
                    />
                  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    <h3 class="u-pad-block-n1 u-pad-block-n2@l">
                      <a href="#" class="c-card__link">Head First Mobile Web</a>
                    </h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed...</p>
                  `);
            }

            getTemplateName() {
                return `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, ``);
            }
        }],
        [65, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/feature-group/feature-group.twig`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 176);

                this.blocks = new Map([
                    ['intro', [this, 'block_intro']],
                    ['content', [this, 'block_content']],
                    ['action', [this, 'block_action']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/feature-group/feature-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_intro(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            <h2 class="c-heading c-heading--level-0 c-heading--light">
              Our open source projects
            </h2>
          `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            `);
                this.echo(this.include(context, this.source, this.loadTemplate(`6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 183, 64), new Map([[`class`, `o-deck--1-column@s o-deck--2-column@l o-deck--align-start`]]), false, false, 183));
                this.echo(`          `);
            }

            block_action(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`class`, `c-button--secondary`], [`label`, `Follow Cloud Four on GitHub`]]), false, false, 281));
                this.echo(`          `);
            }

            getTemplateName() {
                return `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, ``);
            }
        }],
        [64, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/deck/deck.twig`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 183);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/deck/deck.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                `);
                this.echo(this.include(context, this.source, this.loadTemplate(`6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 187, 59), new Map([[`class`, `o-media--1-by-2@l`]]), false, false, 187));
                this.echo(`                `);
                this.echo(this.include(context, this.source, this.loadTemplate(`6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 205, 60), new Map([[`class`, `o-media--1-by-2@l`]]), false, false, 205));
                this.echo(`                `);
                this.echo(this.include(context, this.source, this.loadTemplate(`6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 223, 61), new Map([[`class`, `o-media--1-by-2@l`]]), false, false, 223));
                this.echo(`                `);
                this.echo(this.include(context, this.source, this.loadTemplate(`6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 241, 62), new Map([[`class`, `o-media--1-by-2@l`]]), false, false, 241));
                this.echo(`                `);
                this.echo(this.include(context, this.source, this.loadTemplate(`6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 259, 63), new Map([[`class`, `o-media--1-by-2@l`]]), false, false, 259));
                this.echo(`              `);
            }

            getTemplateName() {
                return `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, ``);
            }
        }],
        [59, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/media/media.twig`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 187);

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/media/media.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/avatar/avatar.twig`, new Map([[`src`, `media/pwastat.jpg`], [`sizes`, `60px`]]), false, false, 191));
                this.echo(`                  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    <h3 class="u-pad-block-n1 u-pad-block-n2@l">
                      <a href="#" class="c-card__link">PWA Stats</a>
                    </h3>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed...
                    </p>
                  `);
            }

            getTemplateName() {
                return `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, ``);
            }
        }],
        [60, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/media/media.twig`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 205);

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/media/media.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/avatar/avatar.twig`, new Map([[`src`, `media/responsive.svg`], [`sizes`, `60px`]]), false, false, 209));
                this.echo(`                  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    <h3 class="u-pad-block-n1 u-pad-block-n2@l">
                      <a href="#" class="c-card__link">Responsive Images</a>
                    </h3>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed...
                    </p>
                  `);
            }

            getTemplateName() {
                return `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, ``);
            }
        }],
        [61, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/media/media.twig`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 223);

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/media/media.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/avatar/avatar.twig`, new Map([[`src`, `media/placeholder.jpg`], [`sizes`, `60px`]]), false, false, 227));
                this.echo(`                  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    <h3 class="u-pad-block-n1 u-pad-block-n2@l">
                      <a href="#" class="c-card__link">Simple SVG Placeholder</a>
                    </h3>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed...
                    </p>
                  `);
            }

            getTemplateName() {
                return `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, ``);
            }
        }],
        [62, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/media/media.twig`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 241);

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/media/media.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/avatar/avatar.twig`, new Map([[`src`, `media/pwastat.jpg`], [`sizes`, `60px`]]), false, false, 245));
                this.echo(`                  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    <h3 class="u-pad-block-n1 u-pad-block-n2@l">
                      <a href="#" class="c-card__link">A Project</a>
                    </h3>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed...
                    </p>
                  `);
            }

            getTemplateName() {
                return `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, ``);
            }
        }],
        [63, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/media/media.twig`, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, 259);

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/media/media.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/avatar/avatar.twig`, new Map([[`src`, `media/responsive.svg`], [`sizes`, `60px`]]), false, false, 263));
                this.echo(`                  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    <h3 class="u-pad-block-n1 u-pad-block-n2@l">
                      <a href="#" class="c-card__link">Another Project</a>
                    </h3>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed...
                    </p>
                  `);
            }

            getTemplateName() {
                return `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf');

let template = env.loadTemplate('6a28d9599a58a1f5fd6114caa3c6bc92f09a749c8c77362fd3b75e404f9da1bf');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/prototypes/case-study-listings/example/example.twig", args: context }
     );
     return rendered;;
};